import { Controller } from 'stimulus';

/**
 * Report-creation wizard, source step. Each source is an option card (mirroring
 * the discharge wizard). Selecting a card's radio highlights it, reveals its
 * in-card detail (the template / existing-report picker) and hides the others.
 * Hidden selects are disabled so their values are never submitted.
 *
 * @target optionCard - each source's card; holds a radio, an optional detail
 *   section, and an optional select.
 */
export default class extends Controller {
  static targets = ['optionCard'];

  connect() {
    this.toggle();
  }

  toggle() {
    const source = this.element.querySelector(
      'input[name="source"]:checked'
    )?.value;

    this.optionCardTargets.forEach((card) => {
      const radio = card.querySelector('input[type="radio"]');
      const active = !!radio && radio.value === source;

      card.classList.toggle('border-primary', active);

      const detail = card.querySelector(
        '[data-wizard-source-target="optionDetail"]'
      );
      if (detail) detail.classList.toggle('d-none', !active);

      // A disabled control is not submitted, so only the active card's picker
      // contributes its value.
      const select = card.querySelector('select');
      if (select) select.disabled = !active;
    });
  }
}
